export default {
  zh: {
    rules: "规则",
    gift: "活动礼物",
    rank: "排行榜",
    task: "任务",
    lastW: "上周",
    thisW: "本周",
    rw: "奖励",
    get: "领取",
    hadGet: "已领取",
    CanGet: "可领取",
    sendGold: ((v) => {
      return `积累发送${v}金币可领取礼物`
    }),
    ruleTxt: `
    1.活动举行四周，活动时间：<br/>
    3.22-3.28 / 3.29-4.4 <br/>
    4.5-4.11 / 4.12-4.18 <br/><br/>
    2.每周二24：00（沙特时间）排行榜和任务积分清零，并会更新活动礼物<br/><br/>
    3.排行榜和任务奖励取决于你送出的开斋节礼物
    `,
    noDone: "未完成",
    sucGet: "领取成功",

    // moon: `发送文字 "Ramadan Mubarak" 或者 "رمضان مبارك" 会落下此特效`,
    // text: `发送文字  会落下此特效`

    moon: `Send the text "Ramadan Kareem" or "رمضان كريم" will drop this special effect`,
    text: `Send the text "Ramadan Mubarak" or "رمضان مبارك" will drop this special effect`,
    star: `Send the text "Eid Mubarak" or "عيد مبارك" will drop this special effect`
  },
  en: {
    rules: "Rules",
    gift: "Activity Gift",
    rank: "Ranking",
    task: "Task",
    lastW: "Last Week",
    thisW: "Week",
    rw: "Reward",
    get: "Get",
    hadGet: "Done",
    CanGet: "Receive",
    sendGold: ((v) => {
      return `Accumulate ${v} gold coins to get gifts`
    }),
    ruleTxt: `
    1. The event will be held for four weeks, and the event time:<br/>
    3.22-3.28 / 3.29-4.4 <br/>
    4.5-4.11 / 4.12-4.18 <br/><br/>
    2. Every Tuesday at 24:00 (Saudi time), the ranking and task points will be cleared, and the event gifts will be updated<br/><br/>
    3. Rankings and mission rewards depend on the Eid gift you give
    `,
    noDone: "Not Finished",
    sucGet: "Successfully received",
    moon: `Send the text "Ramadan Kareem" or "رمضان كريم" will drop this special effect`,
    text: `Send the text "Ramadan Mubarak" or "رمضان مبارك" will drop this special effect`,
    star: `Send the text "Eid Mubarak" or "عيد مبارك" will drop this special effect`
  },
  ar: {
    rules: "القواعد",
    gift: "هدية",
    rank: "الترتيب",
    task: "مهام",
    lastW: "الأسبوع الماضي",
    thisW: "هذا الاسبوع",
    rw: "مكافأة",
    get: "حصلت",
    hadGet: "تم  الحصول",
    CanGet: "حصلت",
    sendGold: ((v) => {
      return `مجموع ${v}ا الذهبية يمكن الحصول على هدايا`
    }),
    ruleTxt: `
    1. سيعقد الحدث لمدة أربعة أسابيع، ووقت الحدث: <br/>
    3.22-3.28 <br/>
    3.29-4.4 <br/>
    4.5-4.11 <br/>
    4.12-4.18 <br/><br/>
    2.كل يوم ثلاثاء في الساعة 24:00 (توقيت السعودية)، سيتم مسح لوحات المتصدرين ونقاط المهام، وسيتم تحديث هدايا الحدث. <br/><br/>
    3. الترتيب ومهام المكافآت تعتمد على هدية عيد أعطيت <br/>
    `,
    noDone: "غير مكتمل",
    sucGet: "تلقى بنجاح",
    moon: `ارسل النص "Ramadan Kareem" او"رمضان كريم" فسوف تاتي المؤثرة الخاصة.`,
    text: `ارسل النص "Ramadan Mubarak" او"رمضان مبارك" فسوف تاتي المؤثرة الخاصة.`,
    star: `ارسل النص "Eid Mubarak" او"عيد مبارك" فسوف تاتي المؤثرة الخاصة.`
  },
  tr: {
    rules: "Kurallar",
    gift: "Activity Gift",
    rank: "Ranking",
    task: "Task",
    lastW: "Last Week",
    thisW: "Week",
    rw: "Reward",
    get: "Get",
    hadGet: "Done",
    CanGet: "Receive",
    sendGold: ((v) => {
      return `Accumulate ${v} gold coins to get gifts`
    }),
    ruleTxt: `
    1. The event will be held for four weeks, and the event time:<br/>
    3.22-3.28 / 3.29-4.4 <br/>
    4.5-4.11 / 4.12-4.18 <br/><br/>
    2. Every Tuesday at 24:00 (Saudi time), the ranking and task points will be cleared, and the event gifts will be updated<br/><br/>
    3. Rankings and mission rewards depend on the Eid gift you give
    `,
    noDone: "Not Finished",
    sucGet: "Successfully received",
    moon: `Send the text "Ramadan Kareem" or "رمضان كريم" will drop this special effect`,
    text: `Send the text "Ramadan Mubarak" or "رمضان مبارك" will drop this special effect`,
    star: `Send the text "Eid Mubarak" or "عيد مبارك" will drop this special effect`
  },
  pt:{
    "rules": "Regras",
    "gift": "Presente da Atividade",
    "rank": "Classificação",
    "task": "Tarefa",
    "lastW": "Semana Passada",
    "thisW": "Semana",
    "rw": "Recompensa",
    "get": "Receber",
    "hadGet": "Concluído",
    "CanGet": "Receber",
    "sendGold": ((v) => {
      return `Acumule ${v} moedas de ouro para obter presentes`
    }),
    "ruleTxt": `
    1. O evento ocorrerá por quatro semanas, e o tempo do evento:<br/>
    22.03-28.03 / 29.03-04.04 <br/>
    05.04-11.04 / 12.04-18.04 <br/><br/>
    2. Toda terça-feira às 24:00 (horário da Arábia Saudita), a classificação e os pontos de tarefa serão zerados, e os presentes do evento serão atualizados<br/><br/>
    3. As classificações e recompensas das missões dependem do presente de Eid que você der
    `,
    "noDone": "Não Concluído",
    "sucGet": "Recebido com sucesso",
    "moon": `Envie o texto "Ramadan Kareem" ou "رمضان كريم" para gerar este efeito especial`,
    "text": `Envie o texto "Ramadan Mubarak" ou "رمضان مبارك" para gerar este efeito especial`,
    "star": `Envie o texto "Eid Mubarak" ou "عيد مبارك" para gerar este efeito especial`
},
    id:{
    "rules": "Aturan",
    "gift": "Hadiah Aktivitas",
    "rank": "Peringkat",
    "task": "Tugas",
    "lastW": "Minggu Lalu",
    "thisW": "Minggu Ini",
    "rw": "Hadiah",
    "get": "Dapatkan",
    "hadGet": "Selesai",
    "CanGet": "Terima",
    "sendGold": ((v) => {
      return `Kumpulkan ${v} koin emas untuk mendapatkan hadiah`
    }),
    "ruleTxt": `
    1. Acara akan berlangsung selama empat minggu, dan waktu acara:<br/>
    22.03-28.03 / 29.03-04.04 <br/>
    05.04-11.04 / 12.04-18.04 <br/><br/>
    2. Setiap hari Selasa pukul 24:00 (waktu Saudi), peringkat dan poin tugas akan direset, dan hadiah acara akan diperbarui<br/><br/>
    3. Peringkat dan hadiah misi bergantung pada hadiah Eid yang Anda berikan
    `,
    "noDone": "Belum Selesai",
    "sucGet": "Berhasil diterima",
    "moon": `Kirim teks "Ramadan Kareem" atau "رمضان كريم" untuk memunculkan efek khusus ini`,
    "text": `Kirim teks "Ramadan Mubarak" atau "رمضان مبارك" untuk memunculkan efek khusus ini`,
    "star": `Kirim teks "Eid Mubarak" atau "عيد مبارك" untuk memunculkan efek khusus ini`
},
    uz:{
    "rules": "Qoidalar",
    "gift": "Faoliyat Sovg'asi",
    "rank": "Reyting",
    "task": "Vazifa",
    "lastW": "O'tgan Hafta",
    "thisW": "Hozirgi Hafta",
    "rw": "Mukofot",
    "get": "Olish",
    "hadGet": "Bajarildi",
    "CanGet": "Qabul Qilish",
    "sendGold": ((v) => {
      return `Sovg'alarni olish uchun ${v} oltin tangani yig'ing`
    }),
    "ruleTxt": `
    1. Tadbir to'rt hafta davom etadi, tadbir vaqti:<br/>
    22.03-28.03 / 29.03-04.04 <br/>
    05.04-11.04 / 12.04-18.04 <br/><br/>
    2. Har seshanba kuni soat 24:00 (Saudiya vaqti) da reytinglar va vazifa ballari tozalanadi, va tadbir sovg'alari yangilanadi<br/><br/>
    3. Reytinglar va missiya mukofotlari berilgan Eid sovg'asiga bog'liq
    `,
    "noDone": "Bajarilmagan",
    "sucGet": "Muvaffaqiyatli qabul qilindi",
    "moon": `Matnni "Ramadan Kareem" yoki "رمضان كريم" yuboring, bu maxsus effektni chiqaradi`,
    "text": `Matnni "Ramadan Mubarak" yoki "رمضان مبارك" yuboring, bu maxsus effektni chiqaradi`,
    "star": `Matnni "Eid Mubarak" yoki "عيد مبارك" yuboring, bu maxsus effektni chiqaradi`
},
    ru:{
    "rules": "Правила",
    "gift": "Подарок мероприятия",
    "rank": "Рейтинг",
    "task": "Задача",
    "lastW": "Прошлая неделя",
    "thisW": "Эта неделя",
    "rw": "Награда",
    "get": "Получить",
    "hadGet": "Сделано",
    "CanGet": "Получить",
    "sendGold": ((v) => {
      return `Накопите ${v} золотых монет, чтобы получить подарки`
    }),
    "ruleTxt": `
    1. Мероприятие будет проводиться в течение четырех недель, и время мероприятия:<br/>
    22.03-28.03 / 29.03-04.04 <br/>
    05.04-11.04 / 12.04-18.04 <br/><br/>
    2. Каждый вторник в 24:00 (саудовское время) рейтинг и очки за задания будут сброшены, а подарки мероприятия будут обновлены<br/><br/>
    3. Рейтинги и награды за миссии зависят от подарка Ид, который вы дарите
    `,
    "noDone": "Не завершено",
    "sucGet": "Успешно получено",
    "moon": `Отправьте текст "Ramadan Kareem" или "رمضان كريم", чтобы получить этот специальный эффект`,
    "text": `Отправьте текст "Ramadan Mubarak" или "رمضان مبارك", чтобы получить этот специальный эффект`,
    "star": `Отправьте текст "Eid Mubarak" или "عيد مبارك", чтобы получить этот специальный эффект`
},
    fa:{
    "rules": "قوانین",
    "gift": "هدیه فعالیت",
    "rank": "رتبه‌بندی",
    "task": "وظیفه",
    "lastW": "هفته گذشته",
    "thisW": "هفته جاری",
    "rw": "پاداش",
    "get": "دریافت",
    "hadGet": "انجام شد",
    "CanGet": "دریافت",
    "sendGold": ((v) => {
      return `جمع‌آوری ${v} سکه طلا برای دریافت هدایا`
    }),
    "ruleTxt": `
    1. این رویداد به مدت چهار هفته برگزار خواهد شد و زمان رویداد به شرح زیر است:<br/>
    22.03-28.03 / 29.03-04.04 <br/>
    05.04-11.04 / 12.04-18.04 <br/><br/>
    2. هر سه‌شنبه ساعت 24:00 (زمان سعودی)، رتبه‌بندی و امتیازات وظایف صفر خواهند شد و هدایای رویداد به‌روزرسانی خواهند شد<br/><br/>
    3. رتبه‌بندی‌ها و پاداش‌های ماموریت بستگی به هدیه عید شما دارند
    `,
    "noDone": "تمام نشده",
    "sucGet": "با موفقیت دریافت شد",
    "moon": `ارسال متن "Ramadan Kareem" یا "رمضان كريم" این افکت ویژه را فعال می‌کند`,
    "text": `ارسال متن "Ramadan Mubarak" یا "رمضان مبارک" این افکت ویژه را فعال می‌کند`,
    "star": `ارسال متن "Eid Mubarak" یا "عيد مبارک" این افکت ویژه را فعال می‌کند`
}



}


// WEBPACK FOOTER //
// src/pages/activity/ramadan/lang.js